import {transparentize} from 'polished';
import styled, {css} from 'styled-components';

import {buttonReset, colors} from '@app/styles/theme';

export const Buttons = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 20px;
`;

export const ItemButton = styled.button<{isActive: boolean; isSimple?: boolean}>`
    ${buttonReset};

    display: flex;
    align-items: center;
    gap: 4px;
    outline: none;
    min-width: 28px;
    height: 28px;
    font-size: 12px;
    padding: 0 8px;
    border-radius: 4px;
    margin: 0 2px;
    user-select: none;

    background-color: ${(p) => (p.isActive ? colors.brandPrimary : colors.transparent)};
    color: ${(p) => (p.isActive ? colors.white : 'inherit')};
    border: 1px solid ${(p) => (p.isActive ? colors.brandPrimary : '#ddd')};

    ${(p) =>
        !p.isActive &&
        css`
            &:hover {
                background-color: ${transparentize(0.9, colors.brandPrimary)};
            }

            &:not(:disabled):active {
                background-color: ${transparentize(0.85, colors.brandPrimary)};
            }
        `}

    &:disabled {
        cursor: default;
    }

    ${(p) =>
        p.isSimple &&
        css`
            &:disabled {
                color: ${colors.textMuted};

                & > * {
                    fill: ${colors.textMuted};
                }
            }
        `}
`;
